import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import "@mdi/font/css/materialdesignicons.css"
import ru from 'vuetify/es5/locale/ru'

Vue.use(Vuetify)

const opts = {
    lang: {
        locales: { ru },
        current: 'ru'
    },
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#0c4d26',
                secondary: '#16604a',
                accent: '#c09e5f',
                error: '#c05858',
                warning: '#b5893b',
                info: '#a0c69d',
                grey: '#808080',
                success: '#5e9c4a'
            }
        }
    }
}

export default new Vuetify(opts)
